import React from 'react';
import { Zoom } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'

import {Link } from "react-router-dom";


  const images = ['https://media.gq.com/photos/56098ff5dfc9eee35e9eb2c6/3:2/w_1998,h_1332,c_limit/American-Buying-Sneakers.jpg',
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8c2hvZXN8ZW58MHx8MHx8&w=1000&q=80',
      'https://i.pinimg.com/originals/9c/f5/56/9cf5567e770cb28096371f909296ac0e.jpg',
      'https://wallpaperaccess.com/full/1444341.jpg',
      'https://wallpapercave.com/wp/wp2896922.jpg',
      'https://images.wallpaperscraft.com/image/single/sneakers_fence_shoes_166550_1920x1080.jpg'];

      const zoomInProperties = {
          indicators: false,
          scale: 1
      }
export default function Home(){
    document.title="Kurd Shoes";
    return (
        <div className='home'>
            <div className='text'>
              <h1>
                  Welcome to Kurd Shoes
              </h1>
              <p>The kurd shoes is a web based application intended for online retailers. The main objective of this application is to make it interactive and its ease of use. It would make searching, viewing and selection of a product easier.</p>
             <div className='buttons'>
              <Link className='button' to={'/Products'}>{'products'}</Link>
               <Link className='button' to={'/Contact'}>{'Contact'}</Link>
             </div>
            </div>
            <div className='slider'>
                <Zoom {...zoomInProperties} className='slides'>
                    {images.map((each, index) => <img className='' key={index} style={{ }} src={each} alt='shoe store' />)}
                </Zoom>
            </div>
        </div>
    );
}
